import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api/errors.js';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          if (error.httpStatus >= 400 && error.httpStatus < 500) {
            return false;
          }
          return failureCount < 1;
        }
        return failureCount < 1;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
